import {registerTemplateGraphNode} from "#template/template-node/register"
import {curveGeometryAttributeLike, curveGeometryAttributeLikeMarker} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {CurveGeometryAttributeLikeNode} from "#template/nodes/geometry-graph/attribute/attribute-node"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {PackOperatorParameters} from "#template/nodes/geometry-graph/attribute/pack-operator/geometry-pack-operator-node"
import {GeometryPackOperatorNode, packOperatorParametersSchema} from "#template/nodes/geometry-graph/attribute/pack-operator/geometry-pack-operator-node"

export type CurveGeometryPackOperatorParameters = PackOperatorParameters<CurveGeometryAttributeLikeNode>

const definition: TemplateNodeDefinition<CurveGeometryPackOperatorParameters> = {
    nodeClass: "CurveGeometryPackOperator",
    validation: {
        parameters: packOperatorParametersSchema(curveGeometryAttributeLike),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class CurveGeometryPackOperator extends GeometryPackOperatorNode<1, CurveGeometryAttributeLikeNode> implements CurveGeometryAttributeLikeNode {
    get [curveGeometryAttributeLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
}
